export const TERMS_VERSION = '1.0';

export const hasAcceptedCurrentTerms = () => (
  localStorage.getItem('mybeef_terms_accepted') === 'true'
  && localStorage.getItem('mybeef_terms_version') === TERMS_VERSION
);

export const saveTermsAcceptance = (acceptedItems) => {
  localStorage.setItem('mybeef_terms_accepted', 'true');
  localStorage.setItem('mybeef_terms_version', TERMS_VERSION);
  localStorage.setItem('mybeef_terms_accepted_date', new Date().toISOString());
  localStorage.setItem('mybeef_terms_accepted_items', JSON.stringify(acceptedItems));
};
